import React, { useEffect, useState } from "react";
import { Link, useNavigate, useSearchParams } from "react-router-dom";
import { FaSpinner } from "react-icons/fa";
import axios from "axios";
import { useDeployAuth } from "../../context/DeployAuthContext";

const deployHttp = axios.create({
  baseURL: "",
  withCredentials: true,
  headers: { "Content-Type": "application/json" },
});

/**
 * Set new password from emailed token (RD-0725).
 */
function DeployResetPasswordPage() {
  const [searchParams] = useSearchParams();
  const token = searchParams.get("token") || "";
  const navigate = useNavigate();
  const { refreshSession } = useDeployAuth();

  const [password, setPassword] = useState("");
  const [busy, setBusy] = useState(false);
  const [error, setError] = useState("");

  useEffect(() => {
    console.log(`[${new Date().toISOString()}] [DeployResetPasswordPage] mount tokenLen=${token.length}`);
  }, [token.length]);

  const handleSubmit = async (e) => {
    e.preventDefault();
    setError("");
    if (!token || token.length < 32) {
      setError("Missing or invalid reset link. Open the link from your email.");
      return;
    }
    setBusy(true);
    const t0 = Date.now();
    try {
      const { data } = await deployHttp.post("/api/deploy/auth/reset-password", {
        token,
        password,
      });
      console.log(
        `[${new Date().toISOString()}] [DeployResetPasswordPage] reset ok ms=${Date.now() - t0}`
      );
      if (data.success) {
        await refreshSession();
        navigate("/limelite/deploy/dashboard", { replace: true });
      }
    } catch (err) {
      const msg = err.response?.data?.error || err.message || "Reset failed";
      setError(msg);
      console.error(`[${new Date().toISOString()}] [DeployResetPasswordPage] error`, msg);
    } finally {
      setBusy(false);
    }
  };

  return (
    <div className="bg-black min-h-[calc(100vh-4rem)] flex items-center justify-center font-sans p-4">
      <div className="bg-off-black rounded-lg p-8 border border-gray-800 w-full max-w-md shadow-xl">
        <h1 className="text-3xl font-serif font-medium text-center mb-2 text-silver-light">
          New password
        </h1>
        <p className="text-center text-silver-medium text-sm mb-6">Choose a strong password (10+ characters).</p>

        <form onSubmit={handleSubmit} className="space-y-5">
          <div>
            <label className="block text-sm font-medium mb-1 text-silver-medium" htmlFor="reset-password">
              New password
            </label>
            <input
              id="reset-password"
              className="bg-black border rounded-md w-full py-2 px-3 text-silver-light leading-tight focus:outline-none focus:ring-1 focus:ring-silver-light border-gray-700"
              type="password"
              value={password}
              onChange={(e) => setPassword(e.target.value)}
              required
              minLength={10}
              autoComplete="new-password"
            />
            <p className="text-xs text-silver-medium mt-1">At least 10 characters.</p>
          </div>

          {error && <p className="text-red-400 text-sm text-center">{error}</p>}

          <button
            type="submit"
            disabled={busy}
            className="w-full bg-black border border-silver-medium hover:bg-silver-medium hover:text-black text-silver-light font-medium py-2 px-6 rounded-md flex items-center justify-center disabled:opacity-50"
          >
            {busy ? <FaSpinner className="animate-spin mr-2" /> : null}
            {busy ? "Saving…" : "Update password"}
          </button>
        </form>

        <p className="text-center mt-6 text-sm text-silver-medium">
          <Link to="/limelite/deploy/login" className="underline hover:text-silver-light">
            ← Back to sign in
          </Link>
        </p>
      </div>
    </div>
  );
}

export default DeployResetPasswordPage;
